module.exports = __webpack_public_path__ + "img/dep_butcher.d5b93780.png";